export default {
    stats: null,
    sales: null,
    activity: null,
    coins: null
}
